import axiosInstance from "../../../utils/axios";
import { ROLE } from "../../../utils/Constants";
const options = { role: ROLE.SUPER_ADMIN };

const path = "admin/rating";

export const List = async (values) => {
    return await axiosInstance(options).post(`${path}/list`, values);
}

export const Add = async (values) => {
    return await axiosInstance(options).post(`${path}/add`, values);
}

export const ChangeStatus = async (values) => {
    return await axiosInstance(options).post(`${path}/change-status`, values);
}

export const Delete = async (values) => {
    return await axiosInstance(options).post(`${path}/delete`, values);
}

export const Reply = async (values) => {
    return await axiosInstance(options).post(`${path}/reply`, values);
}
